import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/js/rem'
import './assets/css/global.css'
import api from './request/api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import PagePagination from '@/components/PagePagination.vue'
import BreadCrumb from '@/components/BreadCrumb.vue'
import PopToast from '@/components/PopToast.vue'
import vueAwesomeCountdown from 'vue-awesome-countdown';

Vue.config.productionTip = false
Vue.component('PagePagination', PagePagination);
Vue.component('BreadCrumb', BreadCrumb);
Vue.component('PopToast', PopToast);
Vue.prototype.$api = api
Vue.use(ElementUI);
Vue.use(vueAwesomeCountdown, 'countdown'); // 'countdown' 和 'vac' 为默认组件名

Vue.mixin({
	beforeRouteEnter(to, from, next) {
		next(() => {
			// 页面切换时，自动滚动到顶部
			window.scrollTo(0, 0);
		});
	}
});

new Vue({
	store,
	router,
	el: '#app',
	render: h => h(App),
}).$mount('#app')